import { backendApiClient } from '@geneo2-web/services-clients';
import { PAL_BASE_URL } from '@geneo2-web/shared-ui';
import { AxiosRequestConfig } from 'axios';

const GET_ADAPTIVE_LEARNING_ENROLLMENT_PATH = `${
  PAL_BASE_URL || ''
}/pal.service.v1.StudentEnrollmentService/GetAdaptiveLearningEnrollment`;

export async function getAdaptiveLearningEnrollment(
  body: unknown,
  options: AxiosRequestConfig = {}
): Promise<void> {
  options.headers = {
    ...options.headers,
    'x-learning-mode': 'adaptive',
  };
  return await backendApiClient.post<void>(
    GET_ADAPTIVE_LEARNING_ENROLLMENT_PATH,
    body,
    options
  );
}

const REGISTER_TO_ADAPTIVE_LEARNING_PATH = `${
  PAL_BASE_URL || ''
}/pal.service.v1.StudentEnrollmentService/RegisterToAdaptiveLearning`;

export async function registerToAdaptiveLearning(
  body: unknown,
  options: AxiosRequestConfig = {}
): Promise<void> {
  options.headers = {
    ...options.headers,
    'x-learning-mode': 'adaptive',
  };
  return await backendApiClient.post<void>(
    REGISTER_TO_ADAPTIVE_LEARNING_PATH,
    body,
    options
  );
}
